<i18n src="@/locales/components/RemindsTranslate.json"></i18n>

<template>
	<div class="cbs-watcher">
		<ReminderConfig
			class="my-4"
			v-for="(remind, index) in localReminds"
			v-model="localReminds[index]"
			:key="`remind-${index}`"
			:formName="`remind-${index}`"
			@onClickDelete="() => deleteItem(remind, index)"
		/>

		<div class="border-dashed my-4 border rounded">
			<vs-button color="#fff" type="filled" class="w-full" text-color="rgb(30,30,30)" @click="addMoreReminds">{{ $t("Addmore") }}</vs-button>
		</div>
	</div>
</template>

<script>
import * as _ from "lodash";

import ReminderConfig from "./ReminderConfig";

const initRemind = {
	period_type: 1,
	milestone_type: 1,
	content: "",
	emails: [],
	relations: [],
	value: 1
};

export default {
	name: "AddReminder",
	props: {
		value: {
			type: Array,
			default: () => []
		}
	},
	components: {
		ReminderConfig
	},
	data() {
		return {};
	},
	computed: {
		localReminds: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		}
	},
	methods: {
		addMoreReminds() {
			this.localReminds = [...this.localReminds, _.cloneDeep(initRemind)];
		},
		deleteItem(remind, index) {
			this.$emit("onDelete", remind, index);
		}
	}
};
</script>
